import React from "react";
import { Box, Stack, Typography, Collapse, IconButton } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CollapsiblePanel = ({ title, icon, children, isOpen, togglePanel }) => {

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        padding: "16px 24px",
        margin: "auto",
        marginBottom: "16px",
        width: "60%",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          variant="h6"
          onClick={togglePanel}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",

            fontFamily: 'Nunito',
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "17.9021px",
            lineHeight: "30px",

            color: "#3A3A3A",
            cursor: "pointer",
          }}
        >
          {icon && <img src={icon} alt={`${title} Icon`} style={{ width: "24px", height: "24px" }} />}
          {title}
        </Typography>
        <IconButton onClick={togglePanel} size="small">
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Stack>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box sx={{ marginTop: "16px" }}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default CollapsiblePanel;
